export function createClickableSection(element) {
  const mainLink = element.querySelector('[data-section-main-link]');
  if (!mainLink) return;

  const button_hidden = mainLink.ariaHidden == 'true';

  const handleSectionClick = () => {
    const isTextSelected = window.getSelection().toString();

    if (!isTextSelected) mainLink.click();
  }

  if (button_hidden && mainLink) element.addEventListener('click', handleSectionClick);
}
